/** Split an app href into path + search for TanStack Router. */
export function parseAppHref(href: string): {
	pathname: string;
	search: Record<string, string> | undefined;
} {
	let trimmed = href.trim();
	if (URL.canParse(trimmed)) {
		const absolute = new URL(trimmed);
		if (absolute.protocol === "http:" || absolute.protocol === "https:") {
			trimmed = `${absolute.pathname}${absolute.search}`;
		}
	}
	const q = trimmed.indexOf("?");
	if (q < 0) return { pathname: trimmed, search: undefined };
	const pathname = trimmed.slice(0, q) || "/";
	const params = new URLSearchParams(trimmed.slice(q + 1));
	const search: Record<string, string> = {};
	for (const [k, v] of params) {
		search[k] = v;
	}
	return {
		pathname,
		search: Object.keys(search).length > 0 ? search : undefined,
	};
}

/** Statuses that should render as failure in the activity feed. */
export function isFailedRunStatus(status: string): boolean {
	return status === "failed" || status === "timeout" || status === "error";
}
